export default __webpack_public_path__ + "ab2ee7ee45c8060f8ed5693f4b88f28e.png";